import type { NavigateFunction } from 'react-router-dom';

/** Persists control-centre calendar deep links across remounts and query clearing. */
export const CALENDAR_VIEW_OVERRIDE_KEY = 'calendarViewOverride';

export type CalendarViewOverride = 'day' | 'month';

export function setCalendarViewOverride(view: CalendarViewOverride): void {
  try {
    sessionStorage.setItem(CALENDAR_VIEW_OVERRIDE_KEY, view);
  } catch {
    // ignore private browsing / quota errors
  }
}

export function getCalendarViewOverride(): CalendarViewOverride | null {
  try {
    const value = sessionStorage.getItem(CALENDAR_VIEW_OVERRIDE_KEY);
    if (value === 'day' || value === 'month') return value;
  } catch {
    // ignore
  }
  return null;
}

export function clearCalendarViewOverride(): void {
  try {
    sessionStorage.removeItem(CALENDAR_VIEW_OVERRIDE_KEY);
  } catch {
    // ignore
  }
}

export function openCalendarWithView(view: CalendarViewOverride, navigate: NavigateFunction): void {
  setCalendarViewOverride(view);
  navigate(`/calendarV2?view=${view}`);
}
